import React, { useState } from 'react'
import { X, Search } from 'lucide-react'
import { ImageProxyService } from '../services/imageProxyService.js'

export const HistoryPanel = ({ character, messages, onClose }) => {
  const [searchTerm, setSearchTerm] = useState('')

  const filteredMessages = messages.filter(msg =>
    msg.content.toLowerCase().includes(searchTerm.toLowerCase())
  )

  const formatTime = (timestamp) => {
    const date = new Date(timestamp)
    return date.toLocaleString('zh-CN')
  }

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-dark-800 rounded-lg w-full max-w-4xl max-h-[80vh] flex flex-col border border-dark-600">
        {/* 头部 */}
        <div className="flex items-center justify-between p-6 border-b border-dark-600">
          <h2 className="text-2xl font-bold text-white">
            与{character.name}的对话历史
          </h2>
          <button
            onClick={onClose}
            className="text-dark-400 hover:text-white transition-colors"
          >
            <X size={24} />
          </button>
        </div>

        {/* 搜索栏 */}
        <div className="p-4 border-b border-dark-600">
          <div className="relative">
            <Search size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-dark-400" />
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="搜索对话..."
              className="w-full bg-dark-700 border border-dark-600 text-white rounded-lg pl-10 pr-4 py-2 focus:outline-none focus:ring-2 focus:ring-primary/50"
            />
          </div>
        </div>

        {/* 消息列表 */}
        <div className="flex-1 overflow-y-auto p-6 space-y-4">
          {filteredMessages.length === 0 ? (
            <div className="text-center text-dark-400 py-20">
              {searchTerm ? '没有找到匹配的消息' : '还没有对话记录'}
            </div>
          ) : (
            filteredMessages.map((message) => (
              <div
                key={message.id}
                className={`flex ${message.sender === 'user' ? 'justify-end' : 'justify-start'}`}
              >
                <div
                  className={`max-w-[70%] rounded-lg px-4 py-2 ${
                    message.sender === 'user'
                      ? 'bg-primary/20 text-white border border-primary/30'
                      : 'bg-dark-700 text-white border border-dark-600'
                  }`}
                >
                  <div className="flex items-center justify-between mb-1">
                    <span className="text-xs text-dark-400">
                      {message.sender === 'user' ? '你' : character.name}
                    </span>
                    <span className="text-xs text-dark-500">
                      {formatTime(message.timestamp)}
                    </span>
                  </div>
                  {message.type === 'image' && message.imageUrl ? (
                    <img
                      src={ImageProxyService.shouldUseProxy(message.imageUrl) 
                        ? ImageProxyService.getProxiedImageUrl(message.imageUrl)
                        : message.imageUrl}
                      alt=""
                      className="max-w-full rounded"
                      onError={async (e) => {
                        const imageUrl = message.imageUrl
                        // 如果当前已经是代理URL，尝试直接URL
                        if (e.target.src.includes('/proxy/image')) {
                          e.target.src = imageUrl
                          return
                        }
                        // 如果直接URL失败，尝试代理URL
                        if (e.target.src === imageUrl && ImageProxyService.shouldUseProxy(imageUrl)) {
                          e.target.src = ImageProxyService.getProxiedImageUrl(imageUrl)
                        }
                      }}
                    />
                  ) : (
                    <div className="text-sm whitespace-pre-wrap">{message.content}</div>
                  )}
                </div>
              </div>
            ))
          )}
        </div>

        {/* 底部统计 */}
        <div className="p-4 border-t border-dark-600 bg-dark-700/50">
          <div className="text-sm text-dark-400">
            共 {messages.length} 条消息
            {searchTerm && `，找到 ${filteredMessages.length} 条匹配`}
          </div>
        </div>
      </div>
    </div>
  )
}

